import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { SiteDocument } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<SiteDocument.Basic>> =>
	Http.get(`${baseUrl}/documents`, { params })

export const downloadDocument = (serviceSiteId: Key, documentId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${serviceSiteId}/documents/${documentId}/download`, {
		responseType: 'blob'
	})
